import React, {useContext, useRef, useState} from 'react';
import './Phone.less';
import {Button} from "elements/button/Button";
import {Input} from "elements/input/Input";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Error} from 'elements/error/Error';
import {Select} from "elements/select/Select";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation, getPhoneCodeForFullLocale, getBrowserFullLocale} from "helpers/localization.helper.ts";
import ReCAPTCHA from "react-google-recaptcha";
import Config from "../../../config";

function getCodeFromPhone(phoneCodes, phone) {
	return phoneCodes.find(phoneCode => new RegExp('^' + phoneCode.value.replace('+', '\\+')).test(phone));
}

export const PHONE_POPUP = 'PHONE_POPUP';

export const Phone = ({phoneCodes, error, isRequestInProgress = false, onCancelClick, onDoneClick, onOverlayClick}) => {
	const defaultPhoneCode = getPhoneCodeForFullLocale(
		phoneCodes,
		getBrowserFullLocale()
	);
	
	const translations = useContext(TranslationsContext);

	const [code, setCode] = useState(defaultPhoneCode.value)
	const [phone, setPhone] = useState(defaultPhoneCode.value);
	const [reCaptchaErrorState, setReCaptchaErrorState] = useState(null);
	
	const [reCaptchaLoaded, setRecaptchaLoaded] = useState(false);
	
	const reCaptchaRef = useRef(null);
	
	const selectChanged = (newCode) => {
		setPhone(newCode + phone.replace(code, ''))
		setCode(newCode);
		setTimeout(() => {
			document.getElementById('phone-number-input').focus();
		}, 200);
	}
	
	const reCaptchaLoadedAsync = () => {
		setRecaptchaLoaded(true);
	}
	const reCaptchaAsyncSubmit = () => {
		reCaptchaRef.current.executeAsync().then(value => {
			if (!value) {
				reCaptchaError();
				return;
			}
			onDoneClick(phone);
			setReCaptchaErrorState(null);
		});
	}
	const reCaptchaError = () => {
		setReCaptchaErrorState(getSafeTranslation('ReCaptcha.error', translations))
	}
	return (<DrawerPopup
		title={getSafeTranslation('PhonePopup.title', translations)}
		description={getSafeTranslation('PhonePopup.description', translations)}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('PhonePopup.cancelButtonCaption', translations)
		}</Button>}
		rightControl={<Button
			isDisabled={isRequestInProgress || !reCaptchaLoaded}
			isAutoWidth
			onClick={() => reCaptchaAsyncSubmit()}
			>
			{getSafeTranslation('PhonePopup.doneButtonCaption', translations)}
		</Button>}
		onOverlayClick={onOverlayClick}
	>
		<div className="phone">
			<div className="phone__input-container">
				<div className="phone__code">
					<Select
						items={phoneCodes.map(phoneCode => ({
							id: phoneCode.value,
							name: phoneCode.description
						}))}
						selectedItemId={code}
						onChange={selectChanged}
					/>
				</div>
				<div className="phone__number">
					<Input
						value={phone}
						inputMode="tel"
						regex={/^[\+\d\s]*$/}
						onChange={newPhone => {
							setPhone(newPhone);
							setCode(getCodeFromPhone(phoneCodes, newPhone).value);
						}}
						focusOnMount
						id={'phone-number-input'}
					/>
				</div>
			</div>
			
			{
				error && (<div className="phone__error">
					<Error text={error}/>
				</div>)
			}
		</div>
		<ReCAPTCHA
			sitekey={Config.reCaptchaSiteKey}
			ref={reCaptchaRef}
			asyncScriptOnLoad={reCaptchaLoadedAsync}
			theme={'dark'}
			size={'invisible'}
			style={{marginTop: '24px'}}
			badge={'inline'}
			onErrored={reCaptchaError}
		/>
		{
			reCaptchaErrorState &&
			(
				<div className="reCaptcha-error">{reCaptchaErrorState}</div>
			)
		}
	</DrawerPopup>)
}
